import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseHttpService } from '@framework/services';
import { map } from 'rxjs/operators';
@Injectable()
export class TrackingHttpService extends BaseHttpService {
    constructor(protected http: HttpClient) {
        super(http, '/track');
    }

    addTrackingIdToStoryOrCampaign(payload){
        return this.post(`/details/`, payload).pipe(
            map((response: any) => {
                return response;
            })
        );
    }

    // getTrackingIdjobsforstory(payload){
    //     return this.get(`/details/`, payload).pipe(
    //         map((response: any) => {
    //             return response;
    //         })
    //     );
    // }

   addHitToStoryOrCampaign(payload){
    return this.post(`/hits/`, payload).pipe(
        map((response: any) => {
            return response;
        })
    );
   } 

   addPersonalizeTrackHit(payload){
    return this.post(`/personalize/`,payload).pipe(
        map((response: any) => {
            return response;
        })
    );
   }

   /**
    * Fetch personalize invite / draft open tracking.
    * @param UniqueToken parent unique_token, or child_token when isChild=true
    * @param fromInner when true, query by unique_token (guest/inbound); else by story_id
    * @param isChild when true, append is_child=1 so API increments both
    *   t_guest_drafts.views and the parent invite's Opened (t_personalised_invite.views)
    */
   getPersonalizeTrackHit(UniqueToken, fromInner, isChild = false){
    if(fromInner){
        const childQs = isChild ? '&is_child=1' : '';
        return this.get(`/personalize/?unique_token=${UniqueToken}${childQs}`).pipe(
            map((response: any) => {
                return response;
            })
        );
    }
    else{
        UniqueToken = +UniqueToken
        return this.get(`/personalize/?story_id=${UniqueToken}`).pipe(
            map((response: any) => {
                return response;
            })
        );
    }

   }

   getTrackHit(companyId){
    return this.get(`/hits-report/${companyId}/`).pipe(
        map((response: any) => {
            return response;
        })
    );
   }
}